<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <!-- {{ teammates }} -->
    <DataGetter
      @dataAvailable="
        data => {
          teammates = data?.metaData?.teammates
          this.isLoading = false
        }
      "
      contentId="teammates"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Equipe et roles</div>
      <div>
        <button class="buttonComponent" @click="addTeammate" v-if="teammates.length > 0">
          Ajouter Collaborateur
        </button>
      </div>
    </div>
    <div class="py-2"></div>

    <div class="relative" v-if="isLoading || teammates.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
          >
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              Collaborateur
            </div>

            <div class="flex gap-6 w-[18rem] min-w-[18rem]">Permissions</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">Date d'ajout</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Dernière modification
            </div>

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div
            v-for="(teammate, index) in isLoading
              ? shimmerTeammates
              : teammates"
            :key="index"
            :class="{ shimmerElement: teammate.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] p-"
              :class="{
                'bg-secondary-100 border border-secondary-300': isOwn(teammate),
                'bg-white': !isOwn(teammate),
              }"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              <img
                :src="teammate.image"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-xl"
              />
              <div class="w-[16rem]">
                <h3 class="font-semibold title-color truncate">
                  {{ isOwn(teammate) ? '(Moi) ' : '' }}
                  {{ teammate.firstName }}
                  {{ teammate.lastName }}
                </h3>
                <p class="truncate text-sm">
                  {{ teammate.email }}
                </p>
              </div>
            </div>

            <div class="gap-6 w-[18rem] min-w-[18rem]">
              <div
                v-for="(permission, i) in teammate.metadata?.permissions.slice(
                  0,
                  4,
                )"
                :key="i"
                class="text-sm inline-block m-1 px-2 py-1 border rounded-full shadow-lg cursor-pointer"
              >
                {{ $t(`permissions.${permission}`) }}
              </div>
              <div
                v-if="teammate.metadata?.permissions?.length > 4"
                :key="i"
                class="text-sm inline-block m-1 px-2 py-1 border rounded-full shadow-lg cursor-pointer"
              >
                +{{ teammate.metadata?.permissions?.length - 4 }}
              </div>
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(teammate.createdAt, 'DD MMM YYYY') }}
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(teammate.updatedAt, 'DD MMM YYYY') }}
            </div>
            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              <DropdownComponent
                :selects="
                  isOwn(teammate)
                    ? [
                        {
                          name: 'Changer mon mot de passe',
                          onClick() {
                            changePassword()
                          },
                        },
                      ]
                    : [
                        {
                          name: 'Modifier',
                          onClick() {
                            updateAccess(teammate)
                          },
                        },
                        {
                          name: 'Supprimer',
                          onClick() {
                            deleteTeammmate(teammate)
                          },
                        },
                      ]
                "
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/personal.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun collaborateur</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Les membre de votre équipes s'affichent ici
        </div>
        <div class="py-2"></div>
        
        <div class="text-lg flex justify-center">
          <button class="buttonComponent" @click="addTeammate">
          Ajouter Collaborateur
        </button>
        </div>
        
      </div>
    </div>
    <EventListener
      :events="['teammate_deleted', 'failed_to_delete_teammate']"
      @teammate_deleted="onTeammateDeleted"
      @failed_to_delete_teammate="onTeammateDeletionFailed"
    />
    <TeammateUpdaterDialog />
    <NewTeammateAdderDialog />
  </div>
</template>

<script>
import NewTeammateAdderDialog from '@/components/team/NewTeammateAdderDialog.vue'
import TeammateUpdaterDialog from '@/components/team/TeammateUpdaterDialog.vue'
import UserProperty from '@/components/user/UserProperty.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    UserProperty,
    NewTeammateAdderDialog,
    TeammateUpdaterDialog,
  },
  data() {
    return {
      eventsIds: [],
      teammates: [],
      activeTab: 'home',
      isLoading: true,
      userData: {},
      shimmerTeammates: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    isOwn(teammate) {
      return teammate.id == this.userData?.reference
    },
    changePassword() {
      this.$Events.dispatchEvent('password_reset_required', {
        email: this.userData?.email,
        userName: this.userData?.firstName,
      })
    },
    addTeammate() {
      this.$Events.dispatchEvent('new_teammate_adding_required')
    },
    updateAccess(teammate) {
      if (teammate.id == this.userData?.reference) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Réussi',
          body: 'Vous ne pouvez pas modifier votre propre compte',
        })
        return
      }

      if (teammate.email == 'admin@ekidiscount.com') {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Réussi',
          body: "Vous ne pouvez pas modifier l'administrateur principal",
        })
        return
      }
      this.$Events.dispatchEvent('new_teammate_update_required', teammate)
    },
    async deleteTeammmate(teammate) {
      if (teammate.id == this.userData?.reference) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Réussi',
          body: 'Vous ne pouvez pas modifier votre propre compte',
        })
        return
      }
      if (teammate.email == 'admin@ekidiscount.com') {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Réussi',
          body: "Vous ne pouvez pas supprimer l'administrateur principal",
        })
        return
      }

      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment retirer ${teammate.firstName} des administrateurs ?`,
          subTitle: `${teammate.firstName} n'aura plus accès au dashboard`,
          successText: 'Supprimer collaborateur',
          cancelText: 'Conserver collaborateur',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('teammate_deletion_requested', {
        id: teammate.id,
      })
    },
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
    onTeammateDeleted() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'Le client a été supprimé avec succès',
      })
    },
    onTeammateDeletionFailed(response) {
      let message = 'Echec lors de la supression du client'
      if (response.teammateNotFound) message = "Ce client n'est plus enrégistré"
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echoué',
        body: message,
      })
    },
  },
}
</script>
